import { toast } from 'sonner';
import {
    ErrorIcon,
    InfoIcon,
    SuccessIcon,
    WarningIcon,
} from '@components/common/Toast/Icons';

// 토스트 타입 정의
export type ToastType = 'error' | 'warning' | 'info' | 'success';

// 토스트 옵션 인터페이스
export interface CustomToastOptions {
    title: string;
    description?: string;
    duration?: number;
    className?: string;
}

// 커스텀 토스트 함수
export const showCustomToast = (
    type: ToastType,
    options: CustomToastOptions,
) => {
    const iconMap = {
        error: <ErrorIcon />,
        warning: <WarningIcon />,
        info: <InfoIcon />,
        success: <SuccessIcon />,
    };

    const classNameMap = {
        error: 'border-red-200 bg-red-50',
        warning: 'border-yellow-200 bg-yellow-50',
        info: 'border-blue-200 bg-blue-50',
        success: 'border-green-200 bg-green-50',
        notification: 'border-indigo-200 bg-indigo-50',
    };

    toast(options.title, {
        className: `${classNameMap[type]} ${options.className || ''} custom-close-left`,
        description: options.description,
        duration: options.duration || 3000,
        icon: iconMap[type],
        closeButton: true,
    });
};

// 각 타입별 편의 함수들
export const toastError = (
    title: string,
    description?: string,
    duration?: number,
) => {
    showCustomToast('error', { title, description, duration });
};

export const toastWarning = (
    title: string,
    description?: string,
    duration?: number,
) => {
    showCustomToast('warning', { title, description, duration });
};

export const toastInfo = (
    title: string,
    description?: string,
    duration?: number,
) => {
    showCustomToast('info', { title, description, duration });
};

export const toastSuccess = (
    title: string,
    description?: string,
    duration?: number,
) => {
    showCustomToast('success', { title, description, duration });
};

// API 에러용 특별한 토스트 함수
export const toastApiError = (message: string, messageDetail?: string) => {
    toastError(
        'API 오류',
        messageDetail ? `${message}: ${messageDetail}` : message,
        7000, // API 에러는 조금 더 길게 표시
    );
};

export const toastApiSuccess = (message: string, messageDetail?: string) => {
    toastSuccess(
        '성공',
        messageDetail ? `${message}: ${messageDetail}` : message,
        3000, // 성공 메시지는 짧게 표시
    );
};
